<template>
  <v-dialog v-model="showDialog" max-width="1900px" persistent scrollable>
    <v-card class="addDevice-modal">
        <v-card-title class="bg-gray-light">
          <span class="text-h5" style="font-size: 1.2rem !important;">{{ $t(nameLabel) }}</span>
          <v-btn class="ml-auto" icon @click.prevent="handleConfirmCloseModal">
            <v-icon id="close-button">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="height: 635px;">
          <v-container style="max-width:1835px !important;" class="pt-0 pb-0">
            <v-form ref="form" v-model="valid" lazy-validation>
              <div class="row mt-0">
                <div class="col-xl-6 col-sm-12">
                  <div class="d-flex justify-content-start ">
                    <h6 class="mb-1 label-black">{{ $t("labels.deviceMaster.deviceName") }}</h6>
                    <h5 class="text-danger mb-0 h-text-danger" v-if="!checkDetail">*</h5>
                  </div>
                  <v-text-field maxlength="50" v-model="deviceInfo.deviceName" hide-details="auto" outlined required dense
                    :disabled="checkDetail || editFlag" :rules="deviceNameRules">
                  </v-text-field>
                </div>
                <div class="col-xl-6 col-sm-12">
                  <div class="d-flex justify-content-start ">
                    <h6 class="mb-1 label-black">{{ $t("labels.deviceMaster.deviceCode") }}</h6>
                    <h5 class="text-danger mb-0 h-text-danger" v-if="!checkDetail">*</h5>
                  </div>
                  <v-text-field maxlength="4" v-model="deviceInfo.deviceCode" hide-details="auto" outlined required dense
                    :disabled="checkDetail || editFlag" @keypress="validateNumber($event)" @paste="onPaste" :rules="deviceCodeRules"
                  ></v-text-field>
                </div>
                <div class="col-xl-6 col-sm-12">
                  <div class="d-flex justify-content-start ">
                    <h6 class="mb-1 label-black">{{ $t("labels.deviceMaster.deviceType") }}</h6>
                    <h5 class="text-danger mb-0 h-text-danger" v-if="!checkDetail">*</h5>
                  </div>
                  <v-select dense outlined required :items="itemsDeviceType" item-value="value" :item-text="($i18n.locale === 'en') ? 'textEn' : 'textJp'" v-model="deviceInfo.vpsType"
                    :disabled="checkDetail || editFlag" :rules="deviceTypeRules" @change="changeDeviceType"></v-select>
                </div>
                <div class="col-xl-6 col-sm-12">
                  <div class="d-flex justify-content-start ">
                    <h6 class="mb-1 label-black">{{ $t("labels.deviceMaster.databaseType") }}</h6>
                    <h5 class="text-danger mb-0 h-text-danger" v-if="!checkDetail">*</h5>
                  </div>
                  <v-text-field maxlength="50" v-model="deviceInfo.databaseType" hide-details="auto" outlined
                     required dense :disabled="checkDetail || editFlag" :rules="databaseTypeRules"></v-text-field>
                </div>
              </div>
            </v-form>
            <div class="row mt-10">
              <div class="col-12">
                <v-form ref="form2" v-model="valid2" lazy-validation>
                  <v-data-table :headers="headers" :items="listTableFilter" sort-by="calories" item-key="index"
                    class="elevation-2" mobile-breakpoint="0" fixed-header locale="ja" hide-default-header hide-default-footer :footer-props="{
                      'items-per-page-options': [200]
                    }">
                    <template slot="no-data">
                      {{ $t("notification.noData") }}
                    </template>
                    <template #header="{ props: { headers } }">
                      <thead>
                        <tr>
                          <th v-for="header in headers" :key="header.value" class="text-uppercase" scope="col">
                            {{ $t(header.text) }}
                          </th>
                        </tr>
                      </thead>
                    </template>
                    <template v-slot:top v-if="!checkDetail && deviceInfo.vpsType">
                      <v-toolbar flat>
                        <div class="d-flex justify-content-start ">
                          <h5 class="mb-2 label-black">{{ $t("labels.deviceMaster.deviceInfo") }}</h5>
                        </div>
                        <v-spacer></v-spacer>
                        <v-btn depressed color="primary" style="background-color: #3d76ad"
                          @click="createItem">
                          <v-icon color="white" size="20" class="mr-2 dark mt-0">
                            mdi-plus-box
                          </v-icon>
                          <span style="font-size: 17px" class="font-weight-bold">{{
                              $t("labels.add")
                          }}</span>
                        </v-btn>
                      </v-toolbar>
                    </template>
                    <template v-slot:[`item.type`]="{ item }">
                      <div class="container type">
                        <v-select dense outlined hide-details="auto" :items="deviceInfoType" item-value="value" :item-text="($i18n.locale === 'en') ? 'textEn' : 'textJp'" v-model="item.type"
                            :disabled="checkDetail" :rules="Rules"  @change="changeTypeInfo(item)">
                        </v-select>
                      </div>
                    </template>
                    <template v-slot:[`item.dataMapping`]="{ item }">
                      <div class="container" :class="deviceInfo.vpsType < 3 || deviceInfo.vpsType == 5? 'dataMapping' : ''">
                        <div :title="item.dataMapping1">
                          <v-select dense outlined hide-details="auto" :class="deviceInfo.vpsType < 3 || deviceInfo.vpsType == 5? 'minw130' :''" :items="filteredOp1Items(item)" item-value="value" item-text="text" v-model="item.dataMapping1"
                              :disabled="checkDetail" :rules="Rules" :search-input.sync="item.searchOp1">
                              <template v-slot:prepend-item>
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-text-field
                                      v-model="item.searchOp1"
                                      :placeholder="getPlaceholder()"
                                      single-line
                                      hide-details
                                    />
                                  </v-list-item-content>
                                </v-list-item>
                              </template>
                          </v-select>
                        </div>
                        <div>
                          <v-select v-if="deviceInfo.vpsType < 3 || deviceInfo.vpsType == 5" class="minw100" dense outlined hide-details="auto" :items="filteredOperation(item)" item-value="value" item-text="text" v-model="item.operation"
                              :disabled="checkDetail || item.type === 2" :rules="Rules" @change="changeOperationItem(item)">
                              <template v-slot:prepend-item>
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-text-field
                                      v-model="item.searchOperation"
                                      :placeholder="getPlaceholder()"
                                      single-line
                                      hide-details
                                    />
                                  </v-list-item-content>
                                </v-list-item>
                              </template>
                          </v-select>
                        </div>
                        <div :title="item.dataMapping2">
                          <v-select v-if="deviceInfo.vpsType < 3 || deviceInfo.vpsType == 5" class="minw130" dense outlined hide-details="auto" :items="filteredOp2Items(item)" item-value="value" item-text="text" v-model="item.dataMapping2"
                              :disabled="checkDetail || item.type === 2 || item.operation === 'abs'" :rules="Rules" :search-input.sync="item.searchOp2">
                              <template v-slot:prepend-item>
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-text-field
                                      v-model="item.searchOp2"
                                      :placeholder="getPlaceholder()"
                                      single-line
                                      hide-details
                                    />
                                  </v-list-item-content>
                                </v-list-item>
                              </template>
                          </v-select>
                        </div>
                      </div>
                    </template>
                    <template v-slot:[`item.headerJP`]="{ item }">
                      <div class="container headerJP">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="item.headerJP" :title="item.headerJP" maxlength="50" hide-details="auto" outlined dense
                              :rules="Rules" :disabled="checkDetail" @keypress.13.prevent v-bind="attrs" v-on="on">
                            </v-text-field>
                          </template>
                          <span>{{ item.headerJP }}</span>
                        </v-tooltip>
                      </div>
                    </template>
                    <template v-slot:[`item.headerEN`]="{ item }">
                      <div class="container headerEN">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="item.headerEN" maxlength="50" hide-details="auto" outlined dense
                              :rules="Rules" :disabled="checkDetail" @keypress.13.prevent v-bind="attrs" v-on="on">
                            </v-text-field>
                          </template>
                          <span>{{ item.headerEN }}</span>
                        </v-tooltip>
                      </div>
                    </template>
                    <template v-slot:[`item.roundingNumber`]="{ item }">
                      <div class="container roundingNumber">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="item.roundingNumber" maxlength="1" hide-details="auto" outlined dense
                              :disabled="checkDetail" @keypress.13.prevent @keypress="validateNumber($event)" @paste="onPaste" v-bind="attrs" v-on="on">
                            </v-text-field>
                          </template>
                          <span>{{ item.roundingNumber }}</span>
                        </v-tooltip>
                      </div>
                    </template>
                    <template v-slot:[`item.unit`]="{ item }">
                      <div class="container unit">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="item.unit" maxlength="10" hide-details="auto" outlined dense :disabled="checkDetail" 
                              @keypress.13.prevent v-bind="attrs" v-on="on">
                            </v-text-field>
                          </template>
                          <span>{{ item.unit }}</span>
                        </v-tooltip>
                      </div>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }" v-if="listTableFilter.length > 1">
                      <div style="width:100px !important;">
                        <button v-if="listTable.length > 0" class="m-1" @click.prevent="onDeleteLine(item)">
                          <i class="fas fa-trash-alt text-danger fa-lg pt-2 pb-2">
                          </i>
                        </button>
                      </div>
                    </template>
                  </v-data-table>
                </v-form>
              </div>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="!checkDetail" class="text-white mr-1" style="background-color: #3d76ad" text
            @click.prevent="handleSaveData">
            {{ $t("labels.deviceMaster.save") }}
          </v-btn>
          <v-btn v-if="checkDetail" class="bg-secondary text-white" text @click.prevent="handleConfirmCloseModal">
            {{ $t("labels.deviceMaster.close") }}
          </v-btn>
          <v-btn v-if="!checkDetail" class="bg-secondary text-white" text @click.prevent="handleConfirmCloseModal">
            {{ $t("labels.deviceMaster.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-overlay :value="loading">
        <v-progress-circular indeterminate size="64" style="color: #3d76ad !important;"></v-progress-circular>
      </v-overlay>
  </v-dialog>
</template>
  
<script>
  import { EventBus } from '@/utils/eventBus.js';
  import { mapActions } from 'vuex';
  import $ from 'jquery';
  import {} from "@/utils/validate";
  export default {
    name: "DeviceVPSEditModal",
    props: ['visible'],
    data() {
      return {
        dataMapping1Options:[],
        operationOptions:[
          {text: '+', value: '+'},
          {text: '-', value: '-'},
          {text: '*', value: '*'},
          {text: '/', value: '/'},
          {text: 'abs', value: 'abs'}
        ],
        dataMapping2Options:[],
        listCheck:[],
        valid: false,
        valid2: false,
        loading: false,
        showDialog: false,
        checkDetail: false,
        deviceInfo: {
          deviceCode: '',
          deviceName: '',
          deviceType: '',
          databaseType: '',
          vpsType: '',
          deviceMasterInfo: [],
          deviceVPSMasterInfo: []
        },
        ERROR_CODE: '',
        nameLabel: "",
        headers: [
          { text: '#', align: 'center', sortable: false, value: 'index', width: "50px" },
          { text: 'labels.deviceVPS.type', value: 'type', align: 'center', sortable: false },
          { text: 'labels.deviceVPS.dataMapping', value: 'dataMapping', align: 'center', sortable: false },
          { text: 'labels.deviceVPS.headerJP', value: 'headerJP', align: 'center', sortable: false },
          { text: 'labels.deviceVPS.headerEN', value: 'headerEN', align: 'center', sortable: false },
          { text: 'labels.deviceVPS.roundingNumber', value: 'roundingNumber', align: 'center', sortable: false },
          { text: 'labels.deviceVPS.unit', value: 'unit', align: 'center', sortable: false },
          { text: 'genba.table.action', value: 'actions', sortable: false, align: 'center' },
        ],
        headerDefault: [],
        listTable: [],
        Rules: [
          (value) => !!value || "",
          (value) => value && !!value.trim() || "",
        ],
        deviceNameRules: [
          (value) => !!value || this.$t("labels.deviceMaster.deviceName") + this.ERROR_CODE['IS_REQUIRED'],
          (value) => value && !!value.trim() || this.$t("labels.deviceMaster.deviceName") + this.ERROR_CODE['IS_REQUIRED'],
        ],
        deviceCodeRules: [
          (value) => !!value || this.$t("labels.deviceMaster.deviceCode") + this.ERROR_CODE['IS_REQUIRED'],
        ],
        deviceTypeRules: [
          (value) => !!value || this.$t("labels.deviceMaster.deviceType") + this.ERROR_CODE['IS_REQUIRED'],
        ],
        databaseTypeRules: [
          (value) => !!value || this.$t("labels.deviceMaster.databaseType") + this.ERROR_CODE['IS_REQUIRED'],
          (value) => value && !!value.trim() || this.$t("labels.deviceMaster.databaseType") + this.ERROR_CODE['IS_REQUIRED'],
        ],
        flagRules:[
          (value) => !!value || "",
        ],
        roundingNumberRules:[
          value => /^\d*$/.test(value) || "",
        ],
        editFlag: false,
        createFlg: false,
        deviceType: null,
        itemsDeviceType: [
          { textEn: 'Navi V', textJp: 'パイルナビV', value: 1 },
          { textEn: 'Navi P', textJp: 'パイルナビP', value: 2 },
          { textEn: 'Navi S', textJp: 'パイルナビS', value: 3 },
          { textEn: 'Navi W', textJp: 'パイルナビW', value: 4 },
          { textEn: 'Other', textJp: '他の', value: 5 },
        ],
        deviceInfoType: [
            { textEn: 'Caculation', textJp: '計算式', value: 1 },
            { textEn: 'Default', textJp: 'デフォルト', value: 2 }
        ]
      }
    },
    updated() {
      if (this.$i18n.locale !== this.currentLocale) {
        this.currentLocale = this.$i18n.locale;
      }
    },
    beforeDestroy() {
      this.loading = false;
    },
    computed: {
      listTableFilter() {
        return this.listTable.filter(item => item.status === 1)
      },
    },
    watch: {
      '$i18n.locale': async function (currentLang) {
        await import(`@/utils/errors/deviceMaster/${currentLang}.js`)
          .then((DATA) => {
            this.ERROR_CODE = DATA.ERROR_CODE
          })
          .catch(async () => {
            await import(`@/utils/errors/deviceMaster/${currentLang}.js`)
              .then((DATA) => {
                this.ERROR_CODE = DATA.ERROR_CODE
              })
          })
      },
      'checkDetail': function (val) {
        if (val) {
          this.headers = [
          { text: '#', align: 'center', sortable: false, value: 'index', width: "50px" },
          { text: 'labels.deviceVPS.type', value: 'type', align: 'center', sortable: false },
          { text: 'labels.deviceVPS.dataMapping', value: 'dataMapping', align: 'center', sortable: false },
          { text: 'labels.deviceVPS.headerJP', value: 'headerJP', align: 'center', sortable: false },
          { text: 'labels.deviceVPS.headerEN', value: 'headerEN', align: 'center', sortable: false },
          { text: 'labels.deviceVPS.roundingNumber', value: 'roundingNumber', align: 'center', sortable: false },
          { text: 'labels.deviceVPS.unit', value: 'unit', align: 'center', sortable: false },
          ]
        } else {
          this.headers = [
          { text: '#', align: 'center', sortable: false, value: 'index', width: "50px" },
          { text: 'labels.deviceVPS.type', value: 'type', align: 'center', sortable: false },
          { text: 'labels.deviceVPS.dataMapping', value: 'dataMapping', align: 'center', sortable: false },
          { text: 'labels.deviceVPS.headerJP', value: 'headerJP', align: 'center', sortable: false },
          { text: 'labels.deviceVPS.headerEN', value: 'headerEN', align: 'center', sortable: false },
          { text: 'labels.deviceVPS.roundingNumber', value: 'roundingNumber', align: 'center', sortable: false },
          { text: 'labels.deviceVPS.unit', value: 'unit', align: 'center', sortable: false },
          { text: 'genba.table.action', value: 'actions', sortable: false, align: 'center' },
          ]
        }
      }
    },
    async beforeMount() {
      const currentLang = this.$i18n.locale
      await import(`@/utils/errors/deviceMaster/${currentLang}.js`)
        .then((DATA) => {
          this.ERROR_CODE = DATA.ERROR_CODE
        })
        .catch(async () => {
          await import(`@/utils/errors/deviceMaster/${currentLang}.js`)
            .then((DATA) => {
              this.ERROR_CODE = DATA.ERROR_CODE
            })
        })
    },
    beforeCreate() {
      this.loading = true;
    },
  
    created() {
      EventBus.$on('handleOpenDeviceVPSEditModal', (value) => {
        if (value.checkDetail || value.editFlag){
          this.handleGetDeviceDetails(value);
        }
        if (value.Flg) {
        $('#main-header').css("pointer-events", "none");
        } else {
        $('#main-header').css("pointer-events", "");
        }
        this.showDialog = value.Flg;
        this.checkDetail = value.checkDetail;
        this.nameLabel = value.nameLabel;
        this.editFlag = value.editFlag;
        this.createFlg = value.createFlg;
        this.deviceType = value.deviceType;
        this.$refs.form?.resetValidation();
        this.$refs.form2?.resetValidation();
      });
      this.headerDefault = this.headers;
      for (let index = 1; index <= 100; index++) {
        var itemOpData = { text: 'data' + index, value: 'Data' + index, option: 1 }
        var itemOpTextBox = { text: 'textdata' + index, value: 'Textdata' + index, option: 2 }
        //Push option 1
        this.dataMapping1Options.push(itemOpData);
        this.dataMapping1Options.push(itemOpTextBox);
        //Push option 2
        this.dataMapping2Options.push(itemOpData);
        this.dataMapping2Options.push(itemOpTextBox);
      }
      this.dataMapping1Options.sort((a, b) => a.option - b.option);
      this.dataMapping2Options.sort((a, b) => a.option - b.option);
    },
    mounted() {
    },
    methods: {
      ...mapActions("deviceMaster", {
        addDevice: "addDeviceVPS",
        updateDevice: "updateDeviceVPS",
        getDeviceVPSDetail: "getDeviceVPSDetail",
      }),
      onKeyDown(event) {
        if (isNaN(event.key)) {
          event.preventDefault();
        }
      },
      onPaste(event){
        if (isNaN(event.clipboardData.getData('text'))) {
          event.preventDefault();
        }
      },
      filteredOp1Items(data) {
        if(data.searchOp1){
          if(data.type == 1){
            return this.dataMapping1Options.filter(item => item.option == 1 &&
              item.text.toLowerCase().includes(data.searchOp1.toLowerCase())
            );
          }
          else{
            return this.dataMapping1Options.filter(item => 
              item.text.toLowerCase().includes(data.searchOp1.toLowerCase())
            );
          }
        }
        else{
          if(data.type == 1){
            return this.dataMapping1Options.filter(item => item.option == 1);
          }
          else{
            return this.dataMapping1Options;
          }
        }
      },
      filteredOp2Items(data) {
        if(data.searchOp2){
          if(data.type == 1){
            return this.dataMapping2Options.filter(item => item.option == 1 &&
              item.text.toLowerCase().includes(data.searchOp2.toLowerCase())
            );
          }
          else{
            return this.dataMapping2Options.filter(item =>
              item.text.toLowerCase().includes(data.searchOp2.toLowerCase())
            );
          }
        }
        else{
          if(data.type == 1){
            return this.dataMapping2Options.filter(item => item.option == 1);
          }
          else{
            return this.dataMapping2Options;
          }
        }
      },
      filteredOperation(data) {
        if(data.searchOperation){
          return this.operationOptions.filter(item => 
            item.text.toLowerCase().includes(data.searchOperation.toLowerCase())
          );
        }
        else{
          return this.operationOptions;
        }
      },
      getPlaceholder() {
        return this.$t("labels.search");
      },
      handleGetDeviceDetails(value) {
        this.showDialog = true;
        this.loading = true;
        this.getDeviceVPSDetail(value.editedItem)
          .then(response => {
            if (response.code === 0) {
              this.deviceInfo = {
                deviceCode: response.data.deviceCode,
                deviceName: response.data.deviceName,
                vpsType: response.data.vpsType,
                databaseType: response.data.databaseType
              }
              this.deviceInfo.deviceVPSMasterInfo = response.data.deviceVPSMasterInfo.map((item, index) => {
                return { ...item, index: index, status: 1, deviceCode: item.deviceCode };
              });
              this.listTable = response.data.deviceVPSMasterInfo.map((item, index) => {
                return { ...item, index: index + 1, status: 1, deviceCode: item.deviceCode};
              });
              this.loading = false;
            }
            else {
              this.commonNotifyVue(this.ERROR_CODE[response.code], 'warning');
              this.loading = false;
            }
          })
          .catch(err => {
            if (err.code != undefined)
              this.commonNotifyVue(this.ERROR_CODE[err.code], 'warning');
            this.loading = false;
          })
          .finally(final => {
            this.isSubmitAction = false;
            this.loading = false;
          });
      },
      createItem() {
        const deviceMasterInfo = {
          index: this.listTable.length + 1,
          type: 2,
          dataMapping1: null,
          operation: null,
          dataMapping2: null,
          headerJP: null,
          headerEN: null,
          roundingNumber: null,
          unit: null,
          status: 1
        };
        this.listTable.push(deviceMasterInfo);
      },
      onDeleteLine(item) {
        var index = this.listTable.map(x => {
          return x.index;
        }).indexOf(item.index);
  
        if (this.listTable[index].status === 1 && (item.id != null || item.id != undefined)) {
          this.commonConfirmVue(this.ERROR_CODE['CONFIRM_DELETE_ORGINFO'], () => {
            this.listTable[index].status = 2;
            this.resetTableIndex()
        });
        }
        else if (item.id == null || item.id == undefined){
          this.listTable.splice(index, 1)
        }
        this.resetTableIndex()
      },
      resetTableIndex(){
        let rawIndex = 1
        this.listTable.forEach((element) => {
          if(element.status === 1){
            element.index = rawIndex
            rawIndex++
            return
          }
          element.index = null
        })
      },
      handleSaveData() {
        this.$refs.form.validate()
        if (!this.$refs.form.validate()) {
          return;
        }
        // if(this.deviceInfo.vpsType === 1){
        //   if(Number(this.deviceInfo.deviceCode) < 5000 || Number(this.deviceInfo.deviceCode) > 5099){
        //     this.commonErrorVue(this.$t("labels.deviceMaster.deviceCode").toLocaleUpperCase() + this.$t("labels.deviceVPS.type1"), 'warning');
        //     return
        //   }
        // }
        // else if(this.deviceInfo.vpsType === 2){
        //   if(Number(this.deviceInfo.deviceCode) < 5100 || Number(this.deviceInfo.deviceCode) > 5199){
        //     this.commonErrorVue(this.$t("labels.deviceMaster.deviceCode").toLocaleUpperCase() + this.$t("labels.deviceVPS.type2"), 'warning');
        //     return
        //   }
        // }
        // else if(this.deviceInfo.vpsType === 3){
        //   if(Number(this.deviceInfo.deviceCode) < 5200 || Number(this.deviceInfo.deviceCode) > 5299){
        //     this.commonErrorVue(this.$t("labels.deviceMaster.deviceCode").toLocaleUpperCase() + this.$t("labels.deviceVPS.type3"), 'warning');
        //     return
        //   }
        // }
        // else if(this.deviceInfo.vpsType === 4){
        //   if(Number(this.deviceInfo.deviceCode) < 5300 || Number(this.deviceInfo.deviceCode) > 5399){
        //     this.commonErrorVue(this.$t("labels.deviceMaster.deviceCode").toLocaleUpperCase() + this.$t("labels.deviceVPS.type4"), 'warning');
        //     return
        //   }
        // }
        // else if(this.deviceInfo.vpsType === 5){
        //   if(Number(this.deviceInfo.deviceCode) < 5400 || Number(this.deviceInfo.deviceCode) > 5499){
        //     this.commonErrorVue(this.$t("labels.deviceMaster.deviceCode").toLocaleUpperCase() + this.$t("labels.deviceVPS.type5"), 'warning');
        //     return
        //   }
        // }
        let checkDevice = true;
        this.listCheck = [];
        this.listTable.forEach((element, i) => {
          if(element.status != 2){
            if ((element.type === null || element.type === undefined || element.type.toString().trim().length === 0) && this.deviceInfo.vpsType !== 3 && this.deviceInfo.vpsType !== 4) {
                this.commonErrorVue(this.$t("labels.deviceVPS.type").toLocaleUpperCase() + this.ERROR_CODE['IS_REQUIRED'], 'warning');
                this.$refs.form2.validate()
                checkDevice = false;
              }
            else if (element.dataMapping1 === null || element.dataMapping1 === undefined || element.dataMapping1?.trim().length === 0) {
              this.commonErrorVue(this.$t("labels.deviceVPS.dataMapping").toLocaleUpperCase() + this.ERROR_CODE['IS_REQUIRED'], 'warning');
              this.$refs.form2.validate()
              checkDevice = false;
            }
            else if ((element.operation === null || element.operation === undefined || element.operation?.trim().length === 0) && element.type !== 2 && this.deviceInfo.vpsType !== 3 && this.deviceInfo.vpsType !== 4) {
              this.commonErrorVue(this.$t("labels.deviceVPS.dataMapping").toLocaleUpperCase() + this.ERROR_CODE['IS_REQUIRED'], 'warning');
              this.$refs.form2.validate()
              checkDevice = false;
            }
            else if ((element.dataMapping2 === null || element.dataMapping2 === undefined || element.dataMapping2?.trim().length === 0) && element.type !== 2 && this.deviceInfo.vpsType !== 3 && element.operation !== 'abs' && this.deviceInfo.vpsType !== 4) {
              this.commonErrorVue(this.$t("labels.deviceVPS.dataMapping").toLocaleUpperCase() + this.ERROR_CODE['IS_REQUIRED'], 'warning');
              this.$refs.form2.validate()
              checkDevice = false;
            }
            else if (element.headerJP === null || element.headerJP === undefined || element.headerJP?.trim().length === 0) {
              this.commonErrorVue(this.$t("labels.deviceVPS.headerJP").toLocaleUpperCase() + this.ERROR_CODE['IS_REQUIRED'], 'warning');
              this.$refs.form2.validate()
              checkDevice = false;
            }
            else if (element.headerEN === null || element.headerEN === undefined || element.headerEN?.trim().length === 0) {
              this.commonErrorVue(this.$t("labels.deviceVPS.headerEN").toLocaleUpperCase() + this.ERROR_CODE['IS_REQUIRED'], 'warning');
              this.$refs.form2.validate()
              checkDevice = false;
            }
            // else{
            //   if(this.listCheck.length > 0){
            //     var findInListCheck = this.listCheck.find(x => x.type == element.type && x.dataMapping1 == element.dataMapping1 && x.operation == element.operation && x.dataMapping2 == element.dataMapping2);
            //     if(findInListCheck){
            //       this.commonErrorVue(this.$t("labels.deviceVPS.dataMapping").toLocaleUpperCase() + this.$t("labels.deviceVPS.unique"), 'warning');
            //       checkDevice = false;
            //     }
            //     else{
            //       this.listCheck.push(element);
            //     }
            //   }
            //   else{
            //     this.listCheck.push(element);
            //   }
            // }
          }
        })
        if (!checkDevice) {
          return;
        }
        
        this.deviceInfo.deviceVPSMasterInfo = this.listTable;
        this.loading = true;
        if (this.editFlag) {
          this.handleUpdateDevice();
        } else {
          this.deviceInfo.deviceType = this.deviceType;
          this.handleAddDevice();
        }
      },
      handleAddDevice() {
        for (var i=0; i<this.deviceInfo.deviceVPSMasterInfo.length; i++){
            if (this.deviceInfo.deviceVPSMasterInfo.length > 0) {
            this.deviceInfo.deviceVPSMasterInfo[i].deviceCode = this.deviceInfo.deviceCode;
          }
        }
        this.addDevice(this.deviceInfo)
          .then(response => {
            if (response.code == 200) {
              this.showDialog = false;
              $('#main-header').css("pointer-events", "");
              this.$emit('handleGetDeviceList', {});
              this.loading = false;
              this.handleResetFormItem();
              this.commonConfirmOKVue(this.ERROR_CODE['SAVE_OK'])
            } else {
              this.loading = false;
              let error_msg = this.ERROR_CODE[response.code];
              this.commonNotifyVue(error_msg, 'warning');
            }
          })
          .catch(err => {
            console.log(err);
            this.loading = false;
            if (err.code != undefined)
              this.commonNotifyVue(this.ERROR_CODE[err.code], 'warning');
          })
          .finally(final => {
            this.isSubmitAction = false;
          });
      },
      handleUpdateDevice() {
        for (var i=0; i<this.deviceInfo.deviceVPSMasterInfo.length; i++){
            if (this.deviceInfo.deviceVPSMasterInfo.length > 0) {
            this.deviceInfo.deviceVPSMasterInfo[i].deviceCode = this.deviceInfo.deviceCode;
          }
        }
        this.updateDevice(this.deviceInfo)
          .then(response => {
            if (response.code == 0) {
              this.showDialog = false;
              $('#main-header').css("pointer-events", "");
              this.$emit('handleGetDeviceList', {});
              this.loading = false;
              this.handleResetFormItem();
              this.commonConfirmOKVue(this.ERROR_CODE['SAVE_OK'])
            } else {
              this.loading = false;
              let error_msg = this.ERROR_CODE[response.code];
              this.commonNotifyVue(error_msg, 'warning');
            }
          })
          .catch(err => {
            console.log(err);
            this.loading = false;
            if (err.code != undefined)
              this.commonNotifyVue(this.ERROR_CODE[err.code], 'warning');
          })
          .finally(final => {
            this.isSubmitAction = false;
          });
      },
      handleConfirmCloseModal() {
        if (this.checkDetail === false) {
          this.commonConfirmVue(this.ERROR_CODE['CF_052_01_01'], () => {
            this.showDialog = false;
            $('#main-header').css("pointer-events", "");
            this.handleResetFormItem();
          });
        } else {
          this.showDialog = false;
          $('#main-header').css("pointer-events", "");
          this.handleResetFormItem();
        }
      },
      handleResetFormItem() {
        this.deviceInfo = {
          deviceCode: '',
          deviceName: '',
          deviceType: '',
          databaseType: '',
          deviceMasterInfo: [],
          deviceVPSMasterInfo: []
        };
        this.listTable = [];
        this.$refs.form?.resetValidation();
        this.$refs.form2?.resetValidation();
      },
      isNumber: function (evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
          evt.preventDefault();
        } else {
          return true;
        }
      },
      changeDeviceType(){
        this.headers = this.headerDefault;
        this.listTable = [];
        if(this.deviceInfo.vpsType === 5){
          this.listTable = [
            { index: 1, type: 1, dataMapping1: "Data4", operation: "-", dataMapping2: "Data2", headerJP: "測点1前後", headerEN: "Measurement Point 1 Front/Back", roundingNumber: 1, unit: "mm", status: 1 },
            { index: 2, type: 1, dataMapping1: "Data3", operation: "-", dataMapping2: "Data1", headerJP: "測点1左右", headerEN: "Measurement Point 1 Left/Right", roundingNumber: 1, unit: "mm", status: 1 },
            { index: 3, type: 1, dataMapping1: "Data7", operation: "-", dataMapping2: "Data2", headerJP: "測点2前後", headerEN: "Measurement Point 2 Front/Back", roundingNumber: 1, unit: "mm", status: 1 },
            { index: 4, type: 1, dataMapping1: "Data6", operation: "-", dataMapping2: "Data1", headerJP: "測点2左右", headerEN: "Measurement Point 2 Left/Right", roundingNumber: 1, unit: "mm", status: 1 },
            { index: 5, type: 2, dataMapping1: "Data3", operation: null, dataMapping2: null, headerJP: "測点1位置/X", headerEN: "Measurement Point 1 Position/X", roundingNumber: 1, unit: "m", status: 1 },
            { index: 6, type: 2, dataMapping1: "Data4", operation: null, dataMapping2: null, headerJP: "測点1位置/Y", headerEN: "Measurement Point 1 Position/Y", roundingNumber: 1, unit: "m", status: 1 },
            { index: 7, type: 2, dataMapping1: "Data5", operation: null, dataMapping2: null, headerJP: "測点1位置/Z", headerEN: "Measurement Point 1 Position/Z", roundingNumber: 1, unit: "m", status: 1 },
            { index: 8, type: 2, dataMapping1: "Data6", operation: null, dataMapping2: null, headerJP: "測点2位置/X", headerEN: "Measurement Point 2 Position/X", roundingNumber: 1, unit: "m", status: 1 },
            { index: 9, type: 2, dataMapping1: "Data7", operation: null, dataMapping2: null, headerJP: "測点2位置/Y", headerEN: "Measurement Point 2 Position/Y", roundingNumber: 1, unit: "m", status: 1 },
            { index: 10, type: 2, dataMapping1: "Data8", operation: null, dataMapping2: null, headerJP: "測点2位置/Z", headerEN: "Measurement Point 2 Position/Z", roundingNumber: 1, unit: "m", status: 1 },
            { index: 11, type: 2, dataMapping1: "Data9", operation: null, dataMapping2: null, headerJP: "X傾斜", headerEN: "X Tilt", roundingNumber: 0, unit: null, status: 1 },
            { index: 12, type: 2, dataMapping1: "Data10", operation: null, dataMapping2: null, headerJP: "Y傾斜", headerEN: "Y Tilt", roundingNumber: 0, unit: null, status: 1 },
            { index: 13, type: 2, dataMapping1: "Textdata1", operation: null, dataMapping2: null, headerJP: "傾斜角度", headerEN: "Tilt Angle", roundingNumber: null, unit: null, status: 1 },
            { index: 14, type: 2, dataMapping1: "Data1", operation: null, dataMapping2: null, headerJP: "設計值/X", headerEN: "Design Value/X", roundingNumber: 3, unit: "m", status: 1 },
            { index: 15, type: 2, dataMapping1: "Data2", operation: null, dataMapping2: null, headerJP: "設計値/Y", headerEN: "Design Value/Y", roundingNumber: 3, unit: "m", status: 1 },
          ]
        }
        else if(this.deviceInfo.vpsType === 4){
          this.headers = this.headers.filter(x => x.value !== 'type');
          this.listTable = [
            { index: 1, type: 2, dataMapping1: "Data1", operation: null, dataMapping2: null, headerJP: "設計値座標X", headerEN: "Design Value Coordinate X", roundingNumber: null, unit: "m", status: 1 },
            { index: 2, type: 2, dataMapping1: "Data2", operation: null, dataMapping2: null, headerJP: "設計値座標Y", headerEN: "Design Value Coordinate Y", roundingNumber: null, unit: "m", status: 1 },
            { index: 3, type: 2, dataMapping1: "Data3", operation: null, dataMapping2: null, headerJP: "設計値座標Z", headerEN: "Design Value Coordinate Z", roundingNumber: null, unit: "m", status: 1 },
            { index: 4, type: 2, dataMapping1: "Data4", operation: null, dataMapping2: null, headerJP: "設計値杭径", headerEN: "Design Value Pile Diameter", roundingNumber: null, unit: "m", status: 1 },
            { index: 5, type: 2, dataMapping1: "Data5", operation: null, dataMapping2: null, headerJP: "設計値杭長", headerEN: "Design Value Pile Length", roundingNumber: null, unit: "m", status: 1 },
            { index: 6, type: 2, dataMapping1: "Data6", operation: null, dataMapping2: null, headerJP: "設計値傾斜角", headerEN: "Design Value Inclination Angle", roundingNumber: null, unit: "°", status: 1 },
            { index: 7, type: 2, dataMapping1: "Data7", operation: null, dataMapping2: null, headerJP: "設計値傾斜方位", headerEN: "Design Value Inclination Azimuth", roundingNumber: null, unit: "°", status: 1 },
            { index: 8, type: 2, dataMapping1: "Data8", operation: null, dataMapping2: null, headerJP: "杭上部偏心量", headerEN: "Pile Top Eccentricity", roundingNumber: null, unit: "m", status: 1 },
            { index: 9, type: 2, dataMapping1: "Data9", operation: null, dataMapping2: null, headerJP: "杭上部X方向", headerEN: "Pile Top X Direction", roundingNumber: null, unit: "m", status: 1 },
            { index: 10, type: 2, dataMapping1: "Data10", operation: null, dataMapping2: null, headerJP: "杭上部Y方向", headerEN: "Pile Top Y Direction", roundingNumber: null, unit: "m", status: 1 },
            { index: 11, type: 2, dataMapping1: "Data11", operation: null, dataMapping2: null, headerJP: "杭上部X座標", headerEN: "Pile Top X Coordinate", roundingNumber: null, unit: "m", status: 1 },
            { index: 12, type: 2, dataMapping1: "Data12", operation: null, dataMapping2: null, headerJP: "杭上部Y座標", headerEN: "Pile Top Y Coordinate", roundingNumber: null, unit: "m", status: 1 },
            { index: 13, type: 2, dataMapping1: "Data13", operation: null, dataMapping2: null, headerJP: "杭上部Z座標", headerEN: "Pile Top Z Coordinate", roundingNumber: null, unit: "m", status: 1 },
            { index: 14, type: 2, dataMapping1: "Data14", operation: null, dataMapping2: null, headerJP: "杭下部偏心量", headerEN: "Pile Bottom Eccentricity", roundingNumber: null, unit: "m", status: 1 },
            { index: 15, type: 2, dataMapping1: "Data15", operation: null, dataMapping2: null, headerJP: "杭下部X方向", headerEN: "Pile Bottom X Direction", roundingNumber: null, unit: "m", status: 1 },
            { index: 16, type: 2, dataMapping1: "Data16", operation: null, dataMapping2: null, headerJP: "杭下部Y方向", headerEN: "Pile Bottom Y Direction", roundingNumber: null, unit: "m", status: 1 },
            { index: 17, type: 2, dataMapping1: "Data17", operation: null, dataMapping2: null, headerJP: "杭下部X座標", headerEN: "Pile Bottom X Coordinate", roundingNumber: null, unit: "m", status: 1 },
            { index: 18, type: 2, dataMapping1: "Data18", operation: null, dataMapping2: null, headerJP: "杭下部Y座標", headerEN: "Pile Bottom Y Coordinate", roundingNumber: null, unit: "m", status: 1 },
            { index: 19, type: 2, dataMapping1: "Data19", operation: null, dataMapping2: null, headerJP: "杭下部Z座標", headerEN: "Pile Bottom Z Coordinate", roundingNumber: null, unit: "m", status: 1 },
            { index: 20, type: 2, dataMapping1: "Data20", operation: null, dataMapping2: null, headerJP: "地表面偏心量", headerEN: "Ground Surface Eccentricity", roundingNumber: null, unit: "m", status: 1 },
            { index: 21, type: 2, dataMapping1: "Data21", operation: null, dataMapping2: null, headerJP: "地表面X方向", headerEN: "Ground Surface X Direction", roundingNumber: null, unit: "m", status: 1 },
            { index: 22, type: 2, dataMapping1: "Data22", operation: null, dataMapping2: null, headerJP: "地表面Y方向", headerEN: "Ground Surface Y Direction", roundingNumber: null, unit: "m", status: 1 },
            { index: 23, type: 2, dataMapping1: "Data23", operation: null, dataMapping2: null, headerJP: "地表面X座標", headerEN: "Ground Surface X Coordinate", roundingNumber: null, unit: "m", status: 1 },
            { index: 24, type: 2, dataMapping1: "Data24", operation: null, dataMapping2: null, headerJP: "地表面Y座標", headerEN: "Ground Surface Y Coordinate", roundingNumber: null, unit: "m", status: 1 },
            { index: 25, type: 2, dataMapping1: "Data25", operation: null, dataMapping2: null, headerJP: "地表面Z座標", headerEN: "Ground Surface Z Coordinate", roundingNumber: null, unit: "m", status: 1 },
            { index: 26, type: 2, dataMapping1: "Textdata1", operation: null, dataMapping2: null, headerJP: "傾斜水平方向", headerEN: "Inclined Horizontal Direction", roundingNumber: null, unit: null, status: 1 },
            { index: 27, type: 2, dataMapping1: "Textdata2", operation: null, dataMapping2: null, headerJP: "傾斜X方向", headerEN: "Inclined X Direction", roundingNumber: null, unit: null, status: 1 },
            { index: 28, type: 2, dataMapping1: "Textdata3", operation: null, dataMapping2: null, headerJP: "傾斜Y方向", headerEN: "Inclined Y Direction", roundingNumber: null, unit: null, status: 1 },
            { index: 29, type: 2, dataMapping1: "Data26", operation: null, dataMapping2: null, headerJP: "傾斜方位", headerEN: "Inclined Azimuth", roundingNumber: null, unit: "°", status: 1 }
          ]
        }
        else if(this.deviceInfo.vpsType === 3){
          this.headers = this.headers.filter(x => x.value !== 'type');
          this.listTable = [
            {index: 1, type: 2, dataMapping1: 'Data5', operation: null, dataMappin2: null,	headerJP: '上測点位置/X', headerEN: 'Upper Measurement Point Position/X', roundingNumber: 3, unit: 'm', status: 1}, 
            {index: 2, type: 2, dataMapping1: 'Data6', operation: null, dataMappin2: null,	headerJP: '上測点位置/Y', headerEN: 'Upper Measurement Point Position/Y', roundingNumber: 3, unit: 'm', status: 1}, 
            {index: 3, type: 2, dataMapping1: 'Data7', operation: null, dataMappin2: null,	headerJP: '上測点位置/Z', headerEN: 'Upper Measurement Point Position/Z', roundingNumber: 3, unit: 'm', status: 1}, 
            {index: 4, type: 2, dataMapping1: 'Data8', operation: null, dataMappin2: null,	headerJP: '下測点位置/X', headerEN: 'Lower Measurement Point Position/X', roundingNumber: 3, unit: 'm', status: 1}, 
            {index: 5, type: 2, dataMapping1: 'Data9', operation: null, dataMappin2: null,	headerJP: '下測点位置/Y', headerEN: 'Lower Measurement Point Position/Y', roundingNumber: 3, unit: 'm', status: 1}, 
            {index: 6, type: 2, dataMapping1: 'Data10', operation: null, dataMappin2: null,	headerJP: '下測点位置/Z', headerEN: 'Lower Measurement Point Position/Z', roundingNumber: 3, unit: 'm', status: 1},
            {index: 7, type: 2, dataMapping1: 'Data11', operation: null, dataMappin2: null,	headerJP: '差分/上', headerEN: 'Difference/Upper', roundingNumber: 0, unit: 'mm', status: 1},
            {index: 8, type: 2, dataMapping1: 'Data12', operation: null, dataMappin2: null,	headerJP: '差分/下', headerEN: 'Difference/Lower', roundingNumber: 0, unit: 'mm', status: 1},
            {index: 9, type: 2, dataMapping1: 'Data1', operation: null, dataMappin2: null,	headerJP: '設計值/X', headerEN: 'Design Value/X', roundingNumber: 3, unit: 'm', status: 1},
            {index: 10, type: 2, dataMapping1: 'Data2', operation: null, dataMappin2: null,	headerJP: '設計值/Y', headerEN: 'Design Value/Y', roundingNumber: 3, unit: 'm', status: 1},
          ];
        }
        else if(this.deviceInfo.vpsType === 2){
          this.listTable = [
            {index: 1, type: 2, dataMapping1: 'Data12', operation:	null, dataMapping2:	null, headerJP: '測点1前後', headerEN: 'Measurement Point 1 Front/Back', roundingNumber: 1, unit: 'mm', status: 1},
            {index: 2, type: 2, dataMapping1: 'Data13', operation:	null, dataMapping2:	null, headerJP: '測点1左右', headerEN: 'Measurement Point 1 Left/Right', roundingNumber: 1, unit: 'mm', status: 1},
            {index: 3, type: 2, dataMapping1: 'Data6', operation:	null, dataMapping2:	null, headerJP: '測点1位置/X', headerEN: 'Measurement Point 1 Position/X', roundingNumber: 3, unit: 'm', status: 1},
            {index: 4, type: 2, dataMapping1: 'Data7', operation:	null, dataMapping2:	null, headerJP: '測点1位置/Y', headerEN: 'Measurement Point 1 Position/Y', roundingNumber: 3, unit: 'm', status: 1},
            {index: 5, type: 2, dataMapping1: 'Data8', operation:	null, dataMapping2:	null, headerJP:	'測点1位置/Z', headerEN: 'Measurement Point 1 Position/Z', roundingNumber: 3, unit: 'm', status: 1},
            {index: 6, type: 2, dataMapping1: 'Data25', operation:	null, dataMapping2:	null, headerJP:	'測点2前後', headerEN: 'Measurement Point 2 Front/Back', roundingNumber: 1, unit: 'mm', status: 1},
            {index: 7, type: 2, dataMapping1: 'Data26', operation:	null, dataMapping2:	null, headerJP:	'測点2左右', headerEN: 'Measurement Point 2 Left/Right', roundingNumber: 1, unit: 'mm', status: 1},
            {index: 8, type: 2, dataMapping1: 'Data19', operation:	null, dataMapping2:	null, headerJP:	'測点2位置/X', headerEN: 'Measurement Point 2 Position/X', roundingNumber: 3, unit: 'm', status: 1},
            {index: 9, type: 2, dataMapping1: 'Data20', operation:	null, dataMapping2:	null, headerJP:	'測点2位置/Y', headerEN: 'Measurement Point 2 Position/Y', roundingNumber: 3, unit: 'm', status: 1},
            {index: 10, type: 2, dataMapping1: 'Data21', operation: null, dataMapping2: null, headerJP: '測点2位置/Z', headerEN:	'Measurement Point 2 Position/Z', roundingNumber: 3, unit: 'm', status: 1},
            {index: 11, type: 2, dataMapping1: 'Data45', operation: null, dataMapping2: null, headerJP: '傾斜計/前後', headerEN: 'Tilt Meter/Front/Back', roundingNumber: 2, unit: '度', status: 1},
            {index: 12, type: 2, dataMapping1: 'Data46', operation: null, dataMapping2: null, headerJP: '傾斜計/左右', headerEN: 'Tilt Meter/Left/Right', roundingNumber: 2, unit: '度', status: 1},
            {index: 13, type: 1, dataMapping1: 'Data45', operation: 'abs', dataMapping2:	null, headerJP: '傾斜差分/前後', headerEN: 'Tilt Difference/Front/Back', roundingNumber: 1, unit: '度', status: 1},
            {index: 14, type: 1, dataMapping1: 'Data46', operation: 'abs', dataMapping2:	null, headerJP: '傾斜差分/左右', headerEN: 'Tilt Difference/Left/Right', roundingNumber: 1, unit: '度', status: 1},
            {index: 15, type: 1, dataMapping1: 'Data3', operation:	'/', dataMapping2: 'Data1', headerJP: '設計值/X', headerEN: 'Design Value/X', roundingNumber: 3, unit: 'm', status: 1},
            {index: 16, type: 1, dataMapping1: 'Data4', operation:	'/', dataMapping2: 'Data2', headerJP: '設計值/Y', headerEN: 'Design Value/Y', roundingNumber: 3, unit: 'm', status: 1},
            {index: 17, type: 1, dataMapping1: 'Data5', operation:	'/', dataMapping2: 'Data3', headerJP: '設計值/Z', headerEN: 'Design Value/Z', roundingNumber: 3, unit: 'm', status: 1},
            {index: 18, type: 1, dataMapping1: 'Data16', operation: '/', dataMapping2: 'Data1', headerJP: '設計值/X', headerEN: 'Design Value/X', roundingNumber: 3, unit: 'm', status: 1},
            {index: 19, type: 1, dataMapping1: 'Data17', operation: '/', dataMapping2: 'Data2', headerJP: '設計值/Y', headerEN: 'Design Value/Y', roundingNumber: 3, unit: 'm', status: 1},
            {index: 20, type: 1, dataMapping1: 'Data18', operation: '/', dataMapping2: 'Data3', headerJP: '設計值/Z', headerEN: 'Design Value/Z', roundingNumber: 3, unit: 'm', status: 1},
            {index: 21, type: 2, dataMapping1: 'Data34', operation: null, dataMapping2: null, headerJP: 'GPS①/X', headerEN: 'GPS①/X', roundingNumber: 3, unit: 'm', status: 1},
            {index: 22, type: 2, dataMapping1: 'Data35', operation: null, dataMapping2: null, headerJP: 'GPS①/Y', headerEN: 'GPS①/Y', roundingNumber: 3, unit: 'm', status: 1},
            {index: 23, type: 2, dataMapping1: 'Data36', operation: null, dataMapping2: null, headerJP: 'GPS①/Z', headerEN: 'GPS①/Z', roundingNumber: 3, unit: 'm', status: 1},
            {index: 24, type: 2, dataMapping1: 'Data37', operation: null, dataMapping2: null, headerJP: 'GPS①/衛星数', headerEN: 'GPS①/Satellite Count', roundingNumber: 0, unit: null, status: 1},
            {index: 25, type: 2, dataMapping1: 'Data38', operation: null, dataMapping2: null, headerJP: 'GPS①/HDOP', headerEN: 'GPS①/HDOP', roundingNumber: 1, unit: null, status: 1},
            {index: 26, type: 2, dataMapping1: 'Textdata2', operation: null, dataMapping2: null, headerJP: 'GPS①/日時', headerEN: 'GPS①/Date and Time', roundingNumber: null, unit: null, status: 1},		
            {index: 27, type: 2, dataMapping1: 'Data39', operation: null, dataMapping2: null, headerJP: 'GPS②/X', headerEN: 'GPS②/X', roundingNumber: 3, unit: 'm', status: 1},
            {index: 28, type: 2, dataMapping1: 'Data40', operation: null, dataMapping2: null, headerJP: 'GPS②/Y', headerEN: 'GPS②/Y', roundingNumber: 3, unit: 'm', status: 1},
            {index: 29, type: 2, dataMapping1: 'Data41', operation: null, dataMapping2: null, headerJP: 'GPS②/Z', headerEN: 'GPS②/Z', roundingNumber: 3, unit: 'm', status: 1},
            {index: 30, type: 2, dataMapping1: 'Data42', operation: null, dataMapping2: null, headerJP: 'GPS②/衛星数', headerEN: 'GPS②/Satellite Count', roundingNumber: 0, unit: null, status: 1},
            {index: 31, type: 2, dataMapping1: 'Data43', operation: null, dataMapping2: null, headerJP: 'GPS②/HDOP', headerEN: 'GPS②/HDOP', roundingNumber: 1, unit: null, status: 1},
            {index: 32, type: 2, dataMapping1: 'Textdata4', operation: null, dataMapping2: null, headerJP: 'GPS②/日時', headerEN: 'GPS②/Date and Time', roundingNumber: null, unit: null, status: 1},		
            {index: 33, type: 2, dataMapping1: 'Data56', operation: null, dataMapping2: null, headerJP: '計測軸', headerEN: 'Measurement Axis', roundingNumber: null, unit: null, status: 1},
            {index: 34, type: 2, dataMapping1: 'Data57', operation: null, dataMapping2: null, headerJP: '計測軸番号', headerEN: 'Measurement Axis Number', roundingNumber: null, unit: null, status: 1},		
            {index: 35, type: 2, dataMapping1: 'Textdata5', operation: null, dataMapping2: null, headerJP: '2軸計測時計測してい', headerEN: 'Measuring 2 Axes', roundingNumber: null, unit: null, status: 1},		
            {index: 36, type: 2, dataMapping1: 'Textdata6', operation: null, dataMapping2: null, headerJP: '2軸計測時計測してい', headerEN: 'Measuring 2 Axes', roundingNumber: null, unit: null, status: 1},
            {index: 37, type: 2, dataMapping1: 'Data1', operation: null, dataMapping2: null, headerJP: '杭計測狀態', headerEN: 'Stake Measurement Status', roundingNumber: null, unit: null, status: 1},
          ];
        }
        else if(this.deviceInfo.vpsType === 1){
          this.listTable = [
          { index: 1, type: 1, dataMapping1: "Data4", operation: "-", dataMapping2: "Data2", headerJP: "測点1前後", headerEN: "Measurement Point 1 Front/Back", roundingNumber: 1, unit: "mm", status: 1 },
            { index: 2, type: 1, dataMapping1: "Data3", operation: "-", dataMapping2: "Data1", headerJP: "測点1左右", headerEN: "Measurement Point 1 Left/Right", roundingNumber: 1, unit: "mm", status: 1 },
            { index: 3, type: 1, dataMapping1: "Data7", operation: "-", dataMapping2: "Data2", headerJP: "測点2前後", headerEN: "Measurement Point 2 Front/Back", roundingNumber: 1, unit: "mm", status: 1 },
            { index: 4, type: 1, dataMapping1: "Data6", operation: "-", dataMapping2: "Data1", headerJP: "測点2左右", headerEN: "Measurement Point 2 Left/Right", roundingNumber: 1, unit: "mm", status: 1 },
            { index: 5, type: 2, dataMapping1: "Data3", operation: null, dataMapping2: null, headerJP: "測点1位置/X", headerEN: "Measurement Point 1 Position/X", roundingNumber: 1, unit: "m", status: 1 },
            { index: 6, type: 2, dataMapping1: "Data4", operation: null, dataMapping2: null, headerJP: "測点1位置/Y", headerEN: "Measurement Point 1 Position/Y", roundingNumber: 1, unit: "m", status: 1 },
            { index: 7, type: 2, dataMapping1: "Data5", operation: null, dataMapping2: null, headerJP: "測点1位置/Z", headerEN: "Measurement Point 1 Position/Z", roundingNumber: 1, unit: "m", status: 1 },
            { index: 8, type: 2, dataMapping1: "Data6", operation: null, dataMapping2: null, headerJP: "測点2位置/X", headerEN: "Measurement Point 2 Position/X", roundingNumber: 1, unit: "m", status: 1 },
            { index: 9, type: 2, dataMapping1: "Data7", operation: null, dataMapping2: null, headerJP: "測点2位置/Y", headerEN: "Measurement Point 2 Position/Y", roundingNumber: 1, unit: "m", status: 1 },
            { index: 10, type: 2, dataMapping1: "Data8", operation: null, dataMapping2: null, headerJP: "測点2位置/Z", headerEN: "Measurement Point 2 Position/Z", roundingNumber: 1, unit: "m", status: 1 },
            { index: 11, type: 2, dataMapping1: "Data9", operation: null, dataMapping2: null, headerJP: "X傾斜", headerEN: "X Tilt", roundingNumber: 0, unit: null, status: 1 },
            { index: 12, type: 2, dataMapping1: "Data10", operation: null, dataMapping2: null, headerJP: "Y傾斜", headerEN: "Y Tilt", roundingNumber: 0, unit: null, status: 1 },
            { index: 13, type: 2, dataMapping1: "Textdata1", operation: null, dataMapping2: null, headerJP: "傾斜角度", headerEN: "Tilt Angle", roundingNumber: null, unit: null, status: 1 },
            { index: 14, type: 2, dataMapping1: "Data1", operation: null, dataMapping2: null, headerJP: "設計值/X", headerEN: "Design Value/X", roundingNumber: 3, unit: "m", status: 1 },
            { index: 15, type: 2, dataMapping1: "Data2", operation: null, dataMapping2: null, headerJP: "設計値/Y", headerEN: "Design Value/Y", roundingNumber: 3, unit: "m", status: 1 },
          ];
        }
      },
      changeTypeInfo(itemData){
        itemData.dataMapping1 = null;
        itemData.dataMapping2 = null;
        itemData.operation = null;
      },
      changeOperationItem(itemData){
        if(itemData.operation === 'abs'){
          itemData.dataMapping2 = null;
        }
      },
      validateNumber(event) {
        const charCode = event.keyCode || event.which;
        if (charCode < 48 || charCode > 57) {
          event.preventDefault();
        }
      },
    }
  }
</script>
  
<style lang="scss" scoped>
  .v-card__actions {
    border-top: 1px solid #ebebeb;
  }
  
  .v-dialog--fullscreen {
    border-radius: 0;
    margin: 0;
    height: 100%;
    position: fixed;
    overflow-y: auto;
    top: 100px;
    left: 0;
  }
  
  .label-black {
    color: black !important;
  }
  
  .h-text-danger {
    height: 2px !important;
  }
  
  .v-input--has-state fieldset {
    border: 2px solid red !important;
  }
  
  .v-messages__message {
    color: red !important;
    padding-left: 0px !important;
    font-size: 15px !important;
  }
  
  .input-port input[type='number'] {
    -moz-appearance: textfield;
  }
  
  .input-port input::-webkit-outer-spin-button,
  .input-port input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  .width-150{
    width: 150px !important;
  }
  
  
  @media only screen and (max-width: 500px) and (max-height: 900px) {
    .addDevice-modal {
      margin-top: 5vh !important;
    }
  }
  
  
  ::v-deep{
    .v-data-table__wrapper {
      overflow-y: auto !important;
      position: relative;
      max-height: 310px;
    }
    .flexMargin {
      margin: -15px 0px -15px 0px;
      padding: 0px 0px 0px 0px;
    }
  
    .data {
      width: 170px !important;
    }
    .type {
      width: 190px !important;
    }
    .orgNameEN {
      width: 170px !important;
    }
    .dataMapping {
      min-width: 130px !important;
      display: flex;
      align-items: center;
    }
    .minw130{
      max-width: 130px !important;
      min-width: 130px !important;
      flex: 1;
    }
    .minw100{
      max-width: 100px !important;
      min-width: 100px !important;
      flex: 1;
    }
    .headerJP {
      min-width: 170px !important;
    }
    .headerEN {
      min-width: 170px !important;
    }
    .unit {
      width: 100px !important;
    }
    .roundingNumber {
      width: 150px !important;
    }
  
    @media only screen and (max-width: 500px) and (max-height: 1000px) and (orientation: portrait) {
    .v-data-table > .v-data-table__wrapper > table > thead > tr > th{
      font-size: 0.5rem !important;
      height: 20px;
      padding: 0px 6px !important;
    }
  
    .v-data-table > .v-data-table__wrapper > table > tbody > tr > td{
      font-size: 0.75rem !important;
      height: 21px !important;
      padding: 0px 6px !important;
    }
    .v-data-footer__pagination {
        margin-left: 4.55rem !important;
      }
    }
  
    @media (min-width: 768px) and (max-width: 1366px) {
      .v-data-table > .v-data-table__wrapper > table > thead > tr > th{
        font-size: 0.8rem !important;
        height: 26px;
        padding: 0px 6px !important;
      }
      .v-data-table > .v-data-table__wrapper > table > tbody > tr > td{
        font-size: 1.2rem !important;
        height: 27px !important;
        padding: 0px 6px !important;
      }
    }
    @media (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 2) {
      .v-data-table > .v-data-table__wrapper > table > thead > tr > th{
        font-size: 1rem !important;
        height: 52px;
        padding: 0px 6px !important;
      }
      .v-data-table > .v-data-table__wrapper > table > tbody > tr > td{
        font-size: 1.5rem !important;
        height: 54px !important;
        padding: 0px 6px !important;
      }
    }
  }
  ::v-deep{
    .v-dialog {
      box-shadow: none !important;
    }
  }
</style>
  